import { setDoc, Timestamp } from "firebase/firestore";
import { ConcertData } from "hooks/useUpcomingConcerts";

export const softDeleteConcert = async (concert: ConcertData) => {
  await setDoc(concert.ref, { deletedAt: Timestamp.now() }, { merge: true });
};
